import { TranslationKey } from "../translations/TranslationKey";

export enum ExamDayType {
  Oral = "Oral",
  Written = "Written",
  Correction = "Correction",
}

export const ExamFormatLabels: { [examType in ExamDayType]: TranslationKey } = {
  [ExamDayType.Oral]: "examDay.field.type.oral",
  [ExamDayType.Written]: "examDay.field.type.written",
  [ExamDayType.Correction]: "examDay.field.type.correction",
};
